import React, { useRef } from 'react';
import { Card, Row, Col, Container } from "react-bootstrap";
import certificate from "../../assets/images/Patents & IPs.jpg";
import wideangle from "../../assets/images/State of the art.jpg";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';


import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/css';

const WhyChooseGautamSolar = () => {

  const sliderRef=useRef();

  const img1 = [
    { img: '/Bis.png' },
    { img: '/CE.png' },
    { img: '/IEC.png' },
    { img: '/SGS.png' },
    { img: '/TUV.png' },
    { img: '/UL.png' }
  ];

  const img2 = [
    // { img: '/1.webp' },

    {img:'/ozoneCert.png'},
    {img:'/kiwi_cert.png'},
    {img:'/certificate.webp'},
    {img:'/certificate2.webp'},
    {img:'/certificate3.webp'},
    { img: '/2.webp' },
    { img: '/3.webp' },
    // { img: '/4.webp' },
    // { img: '/5.webp' },
    { img: '/6.webp' },
    { img: '/Asset 20.png' },
    { img: '/Asset 10.png' },
    { img: '/Asset 30.png' },
    { img: '/Asset 40.png' },

  ];


  return (
    <section className="py-5 text-center container border-top position-relative" >
      <div>
        <div className="col-lg-9 col-md-8 mx-auto text-center">
          <h2 className="textRes" style={{ position: 'relative', color: "black" }}>
            <span style={{
              position: 'absolute',
              top: '-15px',
              left: '50%',
              transform: 'translateX(-50%)',
              borderBottom: '2px solid #faab04',
              width: '50px',
            }}></span>
            WHY <span style={{ fontWeight: 'bold', color: '#a20000' }}>CHOOSE GAUTAM SOLAR</span>
          </h2>
        </div>
      </div>

      <Container className="my-5 px-3 text-center">
        <Row className="elementor-row">
          <Col md={6} className="elementor-column elementor-col-12 mb-4">
            <Card className="elementor-widget elementor-widget-image text-center h-100">

              <img
                style={{ width: '100%', height: '100%' }}
                // variant="top"
                src={wideangle}
                className="img-fluid "
                alt="Multiple Factories"
                width={500}
                height={500}
                loading='lazy'
              />
              <Card.Body>
                <Card.Title style={{ color: "black", fontSize: '14.5px', fontWeight: '700' }}>

                  Fully Automated Setup
                </Card.Title>
                <Card.Text style={{ textAlign: "center", lineHeight: "1.5", color: 'black', fontWeight: '300', fontSize: '18px' }}>
                  Multiple Factories
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="elementor-column elementor-col-12 mb-4">
            <Card className="elementor-widget elementor-widget-image text-center h-100">
              <img
                style={{ width: '100%', height: '100%' }}
                // variant="top"
                src={certificate}
                className="img-fluid"
                alt="Patents & IPs"
                width={500}
                height={500}
                loading='lazy'
              />
              <Card.Body>
                <Card.Title style={{ color: "black", fontSize: '14.5px', fontWeight: '700' }}>
                  Strong focus on R&D and
                  indigenous innovation in the Solar Industry
                </Card.Title>
                <Card.Text style={{ textAlign: "center", lineHeight: "1.5", color: 'black', fontWeight: '300', fontSize: '18px' }}>
                  Patents & IPs
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Quality and Certification */}

      <Container className="py-5 border-top my-4">
        <h2 className="text-center mb-4 text-uppercase textRes">
          Quality & <span style={{ color: '#a20000' }}> Certification</span>
        </h2>

        {/* First Slider */}
        <div className='border'>
          <Swiper
            spaceBetween={10}
            slidesPerView={2}
            autoplay={{
              delay: 100,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            loop={true}
            speed={2000}
            breakpoints={{
              1200: { slidesPerView: 4 },
              992: { slidesPerView: 3 },
              768: { slidesPerView: 2 },
              576: { slidesPerView: 2 },
            }}
            lazy={true}
          >
            {img1.map((item, index) => (
              <SwiperSlide key={index} >
                <div
                  className="bg-white rounded-lg shadow-sm d-flex align-items-center justify-content-center"
                  style={{ height: '100px' }}
                >
                  <img
                    src={item.img}
                    alt={`Cert ${index + 1}`}
                    style={{ width: '90px', objectFit: 'cover' }}
                    loading='lazy'
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Second Slider */}
        <div className="mt-4 border rounded-lg " >
          <Swiper
            ref={sliderRef}
            spaceBetween={10}
            autoplay={{
              delay: 500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            loop={true}
            speed={3000}
            breakpoints={{
              1200: { slidesPerView: 3 },
              992: { slidesPerView: 2 },
              768: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
            }}
            lazy={true}
          >
            {img2.map((item, index) => (
              <SwiperSlide key={index} onMouseEnter={()=>sliderRef.current.swiper.autoplay.stop()} onMouseLeave={()=>sliderRef.current.swiper.autoplay.start()}>
                <div className="bg-white p-1 border d-flex align-items-center justify-content-center" >
                  <img
                    className='rounded '
                    src={item.img}
                    alt={`Media ${index + 1}`}
                    loading='lazy'
                    style={{ maxWidth: '100%', objectFit: 'contain', borderRadius: '12px',height:'400px' }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          
        </div>
      </Container>
    </section>
  );
};

export default WhyChooseGautamSolar;
